// extracted by mini-css-extract-plugin
export default {"cards":"locationValue_cards__I9C2p","info":"locationValue_info__z2Y5H","infoText":"locationValue_infoText__He0zv"};